import create, { SetState, StateCreator, StoreApi } from 'zustand'

interface NextKinInfoStore {
    kinInfo : any,
    setKinInfo : (x:any) => void
    previouskinInfo : any,
    setPreviousKinInfo : (x:any) => void
    clearStore: () => void
}

const initialInput = {patientKin1Name: "",
patientKin2Name : "",
patientKin1Relation : "",
patientKin2Relation : "",
patientKin1PhoneNumber : "",
patientKin2PhoneNum : "",
patientKin1Email : "",
patientKin2Email : "",
patientKin1Address : "",
patientKin2Address : ""}

let  store: StateCreator<NextKinInfoStore, [], [], NextKinInfoStore> | StoreApi<NextKinInfoStore> = (set: SetState<NextKinInfoStore>) => ({
    kinInfo: initialInput,
    setKinInfo: (x) => {
    set(state => ({ kinInfo : x }))
    },
    previouskinInfo: initialInput,
    setPreviousKinInfo: (x) => {
    set(state => ({ previouskinInfo : x }))
    },
  clearStore: () => {
    set(() => ({kinInfo:  undefined}))
    set(() => ({previouskinInfo:  undefined}))
  }
})


export const usenextkinInfoStore  = create(store)